
import React from 'react';
import { DocumentLibrary } from '@/presentation/components/organisms/DocumentLibrary';

export const Documents = () => {
  return <DocumentLibrary />;
};
